import { LiquidityProviders } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'

import { UniswapV2BaseProvider } from './UniswapV2Base'

/**
 *
 */
export class EmberSwapV2Provider extends UniswapV2BaseProvider {
  /**
   * @param {ChainId}chainId
   */
  constructor(chainId: ChainId) {
    const factory = {
      [ChainId.SMARTBCH]: '0xE62983a68679834eD884B9673Fb6aF13db740fF0',
      [ChainId.SMARTBCH_TESTNET]: '0xa27588D9cff3130AC91C39b1B1c992976d492476',
    } as const
    const initCodeHash = {
      [ChainId.SMARTBCH]: '0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a',
      [ChainId.SMARTBCH_TESTNET]:
        '0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a',
    } as const
    super(chainId, factory, initCodeHash)
    this.fee = 0.0025
  }

  /**
   * @return {LiquidityProviders}
   */
  getType(): LiquidityProviders {
    return LiquidityProviders.EmberSwapV2
  }
  /**
   * @return {string}
   */
  getPoolProviderName(): string {
    return 'EmberSwap'
  }
  /**
   * @return {string}
   */
  getPoolProviderURI(): string {
    return 'https://raw.githubusercontent.com/emberswap/assets/master/blockchains/smartbch/assets/0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D/logo.png'
  }
}
